import { render, staticRenderFns } from "./ModalNotificationV2.vue?vue&type=template&id=f5f39e1a&"
import script from "./ModalNotificationV2.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports